// API configuration
// Option 1: Default AWS API Gateway domain (no setup required)
// Option 2: Custom domain (api.yourdomain.com) - requires additional setup
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.execute-api.us-east-1.amazonaws.com/dev';

class ApiService {
  // Get all data
  async getData() {
    try {
      const response = await fetch(`${API_BASE_URL}/data`);
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  // Save new data
  async saveData(data) {
    try {
      const response = await fetch(`${API_BASE_URL}/data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error saving data:', error);
      throw error;
    }
  }

  // Update existing data
  async updateData(id, data) {
    try {
      const response = await fetch(`${API_BASE_URL}/data/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating data:', error);
      throw error;
    }
  }

  // Delete data
  async deleteData(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/data/${id}`, {
        method: 'DELETE',
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting data:', error);
      throw error;
    }
  }
}

export default new ApiService();
